import { render, staticRenderFns } from "./theme-five.vue?vue&type=template&id=90e7201a&"
import script from "./theme-five.vue?vue&type=script&lang=js&"
export * from "./theme-five.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports